import tenantConstants from '@constants';
import tenantUtils from '@utils';
import { getUnifiedTruLeadsStaffDateRangeFilterItem } from '../utils/unifiedTruLeadsLeadFilters';
import { getTimeDateString } from '../../../utility/date';
import { LAST_INTERACTION_SOURCE_OPTIONS } from '../../../components/leads-management/leads-metrics-mock';
import { isUnifiedProfolioEnabled } from '../../../utility/user';
import { t } from 'i18next';

const defaultLeadDateRangeFilters = [
  {
    label: t('Lead Received'),
    key: 'lead_received',
    queryParamKey: ['f[created_at][gte]', 'f[created_at][lte]'],
    placeholder: t('Select Date Range'),
    type: 'dateRange',
    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
  {
    label: t('Last Interaction'),
    key: 'last_interaction',
    queryParamKey: ['f[updated_at][gte]', 'f[updated_at][lte]'],
    placeholder: t('Select Date Range'),
    type: 'dateRange',
    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
];

// TruLeads Simplification (86eye7076): three More Filters added for Bayut KSA only.
// This file lives in common/ (read by eg); oman has its own copy. Gate on the tenant
// flag so the new filters never leak to other LMS tenants.
// TODO(BE): confirm the final query-param keys and option lists; swap Location to the
// shared locationFilter (CityLocationFilter) type once the location source is confirmed.
const getUnifiedLeadsExtraFilters = () =>
  tenantConstants.LMS_ENABLED?.IS_UNIFIED_LEADS_PAGE
    ? // Order (after Users): Location, Last Interaction Source, Overdue Tasks Only.
    [
      {
        // Standalone location picker: lists ALL locations and is usable without first
        // choosing a city (no city → location cascade). Selection applies under
        // f[location_id][] (array).
        type: 'locationOnlyFilter',
        mode: 'multiple',
        label: t('Location'),
        labelProps: { muted: true },
        subList: [
          { key: 'location_id', queryParamKey: 'f[location_id][]', getOptionValue: (item) => item.location_id.toString() },
        ],
      },
      {
        key: 'last_interaction_source',
        queryParamKey: 'f[last_interaction_source]',
        label: t('Last Interaction Source'),
        labelProps: { muted: true },
        placeholder: t('Choose Source'),
        type: 'select',
        list: LAST_INTERACTION_SOURCE_OPTIONS,
        showTag: true,
        singleValue: true,
        getOptionLabel: (e) => t(tenantUtils.getLocalisedString(e, 'name')),
        getOptionValue: (op) => op.id.toString(),
      },
      {
        key: 'overdue_tasks',
        queryParamKey: 'f[overdue_tasks]',
        label: t('Overdue Tasks Only'),
        labelProps: { muted: true },
        type: 'toggle',
      },
    ]
    : [];

// const getLeadsStaffFilters = (users) => [
//   {
//     type: 'unitSelect',
//     label: t('Search By'),
//     key: 'search',
//     subList: [
//       { label: t('Listing ID'), key: 'listing_id', queryParamKey: 'f[interests.listing.id]' },
//       { label: t('REGA Ad License Number'), key: 'ad_license', queryParamKey: 'f[ad_license_number]' },
//       { label: t('Lead ID'), key: 'lead_id', queryParamKey: 'f[lead_client.id]' },
//       { label: t('Lead Name'), key: 'lead_name', queryParamKey: 's[name]' },
//     ],
//   },
//   {
//     label: t('Lead Received'),
//     key: 'lead_received',
//     queryParamKey: ['f[created_at][gte]', 'f[created_at][lte]'],
//     placeholder: t('Select Date Range'),
//     type: 'dateRange',
//     getOptionLabel: (value) => {
//       return value
//         .split(',')
//         .map((e) => getTimeDateString(e, false, true, false, false))
//         .join(' - ');
//     },
//   },
//   {
//     label: t('Last Interaction'),
//     key: 'last_interaction',
//     queryParamKey: ['f[updated_at][gte]', 'f[updated_at][lte]'],
//     placeholder: t('Select Date Range'),
//     type: 'dateRange',

//     getOptionLabel: (value) => {
//       return value
//         .split(',')
//         .map((e) => getTimeDateString(e, false, true, false, false))
//         .join(' - ');
//     },
//   },
// ];

const getLeadsStaffFilters = (users) => [
  {
    type: 'unitSelect',
    label: 'Search By',
    key: 'search',
    subList: [
      { label: t('Listing ID'), key: 'listing_id', queryParamKey: 'q[interests_listing_id_eq]' },
      { label: t('REGA Ad License Number'), key: 'ad_license', queryParamKey: 'q[interests_listing_ad_license_eq]' },
      { label: t('Lead ID'), key: 'lead_id', queryParamKey: 'q[lead_client_id_eq]' },
      { label: t('Lead Name'), key: 'lead_name', queryParamKey: 'q[name_start]' },
    ],
  },
  ...(isUnifiedProfolioEnabled({ featureKey: 'listingsUnified' })
    ? [getUnifiedTruLeadsStaffDateRangeFilterItem()]
    : defaultLeadDateRangeFilters),
  ...(users?.length > 1
    ? [
      {
        key: 'user_id',
        queryParamKey: 'f[user_id]',
        label: t('Users'),
        labelProps: { muted: true },
        placeholder: t('Select Users'),
        type: 'select',
        list: users,
        showTag: true,
        singleValue: true,
        getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'name'),
        getOptionValue: (op) => op.id.toString(),
      },
    ]
    : []),
  ...getUnifiedLeadsExtraFilters(),

  // {
  //   key: 'product_id',
  //   queryParamKey: 'q[product_id_in][]',
  //   label: 'Task Performed',
  //   labelProps: { muted: true },
  //   placeholder: 'Select Task Performed',
  //   type: 'select',
  //   showTag: true,
  //   singleValue: true,
  //   getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'product_title'),
  // },
  // {
  //   key: 'product_id',
  //   queryParamKey: 'q[product_id_in][]',
  //   label: 'Planned Task',
  //   labelProps: { muted: true },
  //   placeholder: 'Select Planned Task',
  //   type: 'select',
  //   showTag: true,
  //   singleValue: true,
  //   getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'product_title'),
  // },
];
export default getLeadsStaffFilters;
